'use client';
import type { CSSProperties, ReactElement } from 'react';
import type { Temper } from '@/types/frontend-types';
import { ContactFormStep, getFooterBackgroundLayout, } from './footerModels';
import { CfooterCodeMask, CfooterGlow, CfooterTriangleDecoration, } from './CfooterBackgroundLayers';
export interface CfooterBackgroundProps {
    isVisible: boolean;
    isMobile: boolean;
    isSubmitting: boolean;
    contactStep: ContactFormStep;
    codingTemper: Temper;
    codingClearOnEnd: boolean;
    codeReplacements: Record<string, string>;
    codingStyle: CSSProperties;
    codingFadeWrapperStyle: CSSProperties;
}
export function CfooterBackground({ isVisible, isMobile, isSubmitting, contactStep, codingTemper, codingClearOnEnd, codeReplacements, codingStyle, codingFadeWrapperStyle, }: CfooterBackgroundProps): ReactElement {
    const backgroundLayout = getFooterBackgroundLayout({ isMobile });
    return (
      <div aria-hidden="true" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
            overflow: 'hidden',
            pointerEvents: 'none',
        }}>
        <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
        }}>
          <CfooterTriangleDecoration isVisible={isVisible} frameStyle={backgroundLayout.triangleFrameStyle}/>
          <CfooterGlow isVisible={isVisible} glowStyle={backgroundLayout.glowStyle}/>
          <CfooterCodeMask isVisible={isVisible} isSubmitting={isSubmitting} contactStep={contactStep} codingTemper={codingTemper} codingClearOnEnd={codingClearOnEnd} codeReplacements={codeReplacements} codingStyle={codingStyle} codingFadeWrapperStyle={codingFadeWrapperStyle} codeMaskStyle={backgroundLayout.codeMaskStyle}/>
        </div>
      </div>
    );
}
